export const urlMixin = {
    computed: {
        url(){
            return `${process.env.VUE_APP_API_URL}attachments`
        },
    },
}
